import React, { Component } from 'react';
import Index from '../components/Screening/Index';
import WebpackerReact from 'webpacker-react';

class ScreeningIndex extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <React.Fragment>
                <Index
                    current_url={this.props.current_url}
                    sources={this.props.sources}
                />
            </React.Fragment>
        );
    }
}

export default ScreeningIndex;
WebpackerReact.setup({ ScreeningIndex });
